export var CHANGE_AMOUNT_INPUT_TEST_ID = 'CHANGE_AMOUNT_INPUT_TEST_ID';
export var CHANGE_AMOUNT_BUTTON_PLUS_TEST_ID = 'CHANGE_AMOUNT_BUTTON_PLUS_TEST_ID';
export var CHANGE_AMOUNT_BUTTON_MINUS_TEST_ID = 'CHANGE_AMOUNT_BUTTON_MINUS_TEST_ID';
export var CHANGE_AMOUNT_CONTAINER_TEST_ID = 'CHANGE_AMOUNT_CONTAINER_TEST_ID';